module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ANzJQw/images/e9781439636602_cover.jpg?1684305843592",
      "alt": "This image is the cover for the book Metro Detroit's High School Basketball Rivalries, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Metro Detroit's High School Basketball Rivalries, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Few cities can claim a hardwood heritage like that found in metro Detroit. Metro Detroit has been the epicenter for cataclysmic change in the past 60 years that no other major American city has suffered, but the one constant among so much upheaval is a passionate following afforded high school basketball. The rise and fall of the automotive industry, the Motown record label's emergence and eventual relocation, social and racial unrest, and the polarization of one of America's great cities has not slowed the love and passion Detroiters-city and suburban dwellers alike-share for prep basketball.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      T.C. Cameron\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("T. C. Cameron is an accomplished blogger, writer, and referee. He also wrote Metro Detroit's High School Football Rivalries. The Write Referee, Cameron's blog, is syndicated by 27 newspapers. Cameron holds membership in the American Society of Journalists and Authors, the Society of Professional Journalists, and the Detroit Sports Broadcasters Association.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0